import { User } from 'states';

/**
 * A newly onboarded user logs in with the default password emailed to them.
 * The login API reports this as `passwordUpdated: false` (same contract as the
 * MIS Web App); they must set their own password before using the console.
 * Only an explicit `false` counts - a missing flag (e.g. a session stored before
 * the field existed) must not lock anyone out.
 */
export const isPasswordChangeRequired = (user?: Partial<User> | null): boolean => user?.passwordUpdated === false;

export const withPasswordUpdated = <T extends Partial<User>>(user: T): T => ({ ...user, passwordUpdated: true });
